import { render } from "./InventoryCountForm.vue?vue&type=template&id=2b7d0228"
import script from "./InventoryCountForm.vue?vue&type=script&lang=js"
export * from "./InventoryCountForm.vue?vue&type=script&lang=js"
script.render = render

export default script